import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProductsService } from 'src/app/products.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, AfterViewInit {

  year: number = 2023;
  cnlink: boolean = false;

  constructor(
    public translate: TranslateService,
    public _router: Router,
    public _productsService: ProductsService,
    ) {
  }
  productcards: any[];

  ngOnInit(): void {
    // console.log(window.location.hostname);
    
    // if(window.location.hostname == "www.veexinc.cn" || window.location.hostname == "localhost"){
    //   this.cnlink = true;
    // }
  }

  get checkHost() {
    return window.location.hostname == "www.veexinc.cn";
  }

  loadProducts() {
    this.productcards = this._productsService.productcards;
  }

  ngAfterViewInit(){
    // console.log(window.location.hostname);
    this.year = new Date().getFullYear();
    
    if(window.location.hostname == "www.veexinc.cn" || window.location.hostname == "localhost"){
      this.cnlink = true;
    } else if (window.location.hostname == "www.veexinc.com"){
      this.cnlink = false;
    }
    if (this._router.url.indexOf('veexinc.cn') > -1 || window.location.hostname == "www.veexinc.cn") {
      this.cnlink = true;
    }
  }

}
